module.exports = __webpack_public_path__ + "assets/home-min.d019fc673d0305f86d1c91a8601023c7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/VictorSantacana/home-min.jpg
 ** module id = 420
 ** module chunks = 0
 **/